import React from 'react';
import { useDashboard } from 'hooks';
import getType from 'utils/deviceType';

const presenceName = (name) => name.replace(/\s*iphone\s*/i, '').trim();

function StatusBar() {
	const { items } = useDashboard();

	if (!items || items.length === 0) return null;

	const allItems = items.flatMap((g) => g.items);

	const presenceItems = allItems.filter(
		(item) => item.module === 'unifi' || getType(item) === 'mobile'
	);

	const doorItem = allItems.find((item) => getType(item) === 'door');

	const generalGroup =
		items.find((g) => g.name === 'Generellt') || items[0];
	const outdoorTemp = generalGroup
		? generalGroup.items.find((item) => getType(item) === 'temperature')
		: null;
	const outdoorHumidity = generalGroup
		? generalGroup.items.find((item) => getType(item) === 'humidity')
		: null;

	return (
		<div className="flex items-center gap-4 px-6 py-2 text-xs text-[--color-text-secondary] border-b border-[--color-border-subtle] bg-[--color-bg-primary]">
			{presenceItems.map((item) => (
				<div key={item.deviceId} className="flex items-center gap-1.5">
					<span
						className={`w-1.5 h-1.5 rounded-full ${item.values && item.values.guiOn ? 'bg-cr-green' : 'bg-gray-300'}`}
					/>
					{presenceName(item.name)} –{' '}
					{item.values && item.values.guiOn ? 'Hemma' : 'Borta'}
				</div>
			))}

			{doorItem && (
				<div className="flex items-center gap-1.5">
					<span
						className={`w-1.5 h-1.5 rounded-full ${doorItem.values && doorItem.values.guiOn ? 'bg-amber-400' : 'bg-gray-300'}`}
					/>
					{doorItem.name} –{' '}
					{doorItem.values && doorItem.values.guiOn ? 'Öppen' : 'Stängd'}
				</div>
			)}

			{(outdoorTemp || outdoorHumidity) && (
				<div className="ml-auto text-[11px]">
					{outdoorTemp && outdoorTemp.values && (
						<span>{outdoorTemp.values.description}</span>
					)}
					{outdoorTemp && outdoorHumidity && (
						<span className="mx-1 text-[--color-text-tertiary]">·</span>
					)}
					{outdoorHumidity && outdoorHumidity.values && (
						<span>{outdoorHumidity.values.description} luftfuktighet</span>
					)}
				</div>
			)}
		</div>
	);
}

export default StatusBar;
